import { Button, cn } from '@repo/ui';
import { Moon, Sun } from 'lucide-react';
import type { ReactElement } from 'react';
import { useTheme } from '@/hooks/useTheme';

export function ThemeToggle(): ReactElement {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      aria-label={theme === 'dark' ? 'Activar modo claro' : 'Activar modo oscuro'}
      className={cn('size-7', '**:[&>svg]:size-3.5')}
    >
      {theme === 'dark' ? <Sun aria-hidden="true" /> : <Moon aria-hidden="true" />}
    </Button>
  );
}
